import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

class ScrollTop extends React.Component<RouteComponentProps> {
    componentDidUpdate(prevProps: RouteComponentProps): void {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    render(): React.ReactNode {
        return this.props.children;
    }
}

export default withRouter(ScrollTop);